import {createContext} from 'react'
import {ReceiptContext} from './_context'

export const ReceiptProvider = ReceiptContext.Provider
